import { useMemo, useState } from 'react';
import { Popover } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileLines } from '@fortawesome/free-solid-svg-icons';
import { SearchInput, StatusPill } from '../../components';
import { useTemplatesQuery } from '../../queries/templates';
import { CATEGORY_META } from './constants';
import TemplateText from './TemplateText';
import {
  LinkBtn,
  Muted,
  Picker,
  PickerBody,
  PickerEmpty,
  PickerHead,
  PickerItem,
  PickerList,
  PickerTitle
} from './styled';

const POPOVER_STYLES = { body: { padding: 0 } };

function TemplateList({ onPick }) {
  const { data: templates = [], isLoading } = useTemplatesQuery();
  const [query, setQuery] = useState('');

  const visible = useMemo(() => {
    const q = query.trim().toLowerCase();
    return q ? templates.filter((t) => `${t.title} ${t.body}`.toLowerCase().includes(q)) : templates;
  }, [templates, query]);

  return (
    <Picker>
      <PickerHead>
        <div>
          <h3>Insert template</h3>
          <Muted $small>{templates.length} saved</Muted>
        </div>
        <SearchInput value={query} onChange={setQuery} placeholder="Search templates…" minWidth={0} square />
      </PickerHead>
      {isLoading ? (
        <PickerEmpty>Loading templates…</PickerEmpty>
      ) : visible.length === 0 ? (
        <PickerEmpty>{templates.length ? 'No templates match.' : 'No templates yet. Add one in the Templates tab.'}</PickerEmpty>
      ) : (
        <PickerList>
          {visible.map((t) => {
            const meta = CATEGORY_META[t.category] || CATEGORY_META.general;
            return (
              <li key={t._id}>
                <PickerItem type="button" onClick={() => onPick(t)}>
                  <PickerTitle>
                    {t.title}
                    <StatusPill color={meta.color} style={{ fontSize: 11, padding: '1px 8px' }}>
                      {meta.label}
                    </StatusPill>
                  </PickerTitle>
                  <PickerBody>
                    <TemplateText text={t.body} />
                  </PickerBody>
                </PickerItem>
              </li>
            );
          })}
        </PickerList>
      )}
    </Picker>
  );
}

export default function TemplatePicker({ onPick, disabled }) {
  const [open, setOpen] = useState(false);

  const pick = (t) => {
    setOpen(false);
    onPick(t);
  };

  return (
    <Popover
      content={<TemplateList onPick={pick} />}
      trigger="click"
      placement="topLeft"
      arrow={false}
      open={open}
      onOpenChange={setOpen}
      styles={POPOVER_STYLES}
      destroyOnHidden
    >
      <LinkBtn type="button" disabled={disabled} aria-haspopup="dialog" aria-expanded={open}>
        <FontAwesomeIcon icon={faFileLines} />
        Insert template
      </LinkBtn>
    </Popover>
  );
}
